import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mt-3"
}
const _hoisted_4 = {
  key: 2,
  class: "alert alert-danger mt-3"
}
const _hoisted_5 = {
  key: 3,
  class: "animation-spacer"
}
const _hoisted_6 = { class: "user-list-spacer" }
const _hoisted_7 = { class: "small-text" }
const _hoisted_8 = { class: "team-members" }
const _hoisted_9 = {
  key: 1,
  class: "small-text empty-state-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_UserListItem = _resolveComponent("UserListItem")!
  const _component_ButtonElement = _resolveComponent("ButtonElement")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_ModalLayout = _resolveComponent("ModalLayout")!

  return (_openBlock(), _createBlock(_component_ModalLayout, {
    "has-close-button": false,
    class: "search-user-modal",
    onOnClose: _ctx.refreshTeam
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-outline-light",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.popModal()))
      }, _toDisplayString(_ctx.$t('modals.search_users.cancel')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "text",
          placeholder: _ctx.$t('modals.search_users.placeholder'),
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
        }, null, 8, _hoisted_1), [
          [_vModelText, _ctx.searchValue]
        ])
      ], 32),
      (_ctx.inviteUserError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.inviteUserError), 1))
        : _createCommentVNode("", true),
      (_ctx.searchError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('errors.search_users.no_fetch')), 1))
        : _createCommentVNode("", true),
      (_ctx.errorLoadMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('errors.search_users.load_more')), 1))
        : _createCommentVNode("", true),
      (_ctx.searchLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_lottie_animation, {
              class: "loading-animation",
              animationData: require('@/assets/animations/loader.json'),
              loop: true,
              autoPlay: true,
              speed: 1
            }, null, 8, ["animationData"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.searchResult !== undefined)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.searchResult.length !== 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('modals.search_users.results')), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (member) => {
                        return (_openBlock(), _createBlock(_component_UserListItem, {
                          key: member.user_id,
                          member: member,
                          "invite-on-click": true,
                          editErrorInviteUser: _ctx.editErrorInviteUser,
                          onOnInvite: _ctx.refreshTeam
                        }, null, 8, ["member", "editErrorInviteUser", "onOnInvite"]))
                      }), 128))
                    ]),
                    (_ctx.showLoadMoreButton)
                      ? (_openBlock(), _createBlock(_component_ButtonElement, {
                          key: 0,
                          class: "w-100 load-more-button",
                          theme: "outline-light",
                          type: "button",
                          loading: _ctx.loadingLoadMore,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMore()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('modals.search_users.load_more')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.searchResult.length === 0 && !_ctx.searchLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_i18n_t, { keypath: "modals.search_users.no_results" }, {
                      name: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.searchValue), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}